import { batteryLevelPlotDef, motionPlotDef } from "helpers/config/dashboards/device"

export const alertTypeDefs = {
  sentrisense_motion: motionPlotDef,
  battery_level: batteryLevelPlotDef,
}
